export default "__VITE_ASSET__db2131ed__"